<template>
    <div>
      <vs-button @click="open">{{title}}</vs-button>
      <vs-prompt
          title="Add Story"
          accept-text="Add Story"
          button-cancel="border"
          @accept="addStory"
          @close="close"
          :is-valid="validateForm"
          :active.sync="activePrompt"
      >
          <EditForm
              v-if="activePrompt"
              :activePrompt="activePrompt"
              :story="storyLocal"
              @update="updateLocalStory"
              @accept="addStory"
              @close="close"
          />
      </vs-prompt>
    </div>
</template>
<script>
import EditForm from './EditForm'
import trackAnalytics from '@/helpers/trackAnalytics'

export default {
  components: {
    EditForm,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'Add Story'
    },
  },

  data () {
    return {
      activePrompt: false,
      storyLocal: {},
      storyDefaults: {
        title: null,
        desc: null,
        isStarred: false,
        tag: null,
      }
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.storyLocal.title
    },
    defaultTag () {
      return this.$route.params.filter === 'all' || this.$route.params.filter === 'starred' ? 'note' : this.$route.params.filter
    }
  },
  mounted () {
    this.clearFields()
  },
  watch: {
    'activePrompt': {
      async handler (promptActive) {
        if (promptActive) {
          await this.$validator.resume()
        } else {
          await this.$validator.pause()
        }
      }
    },
    // TODO: refactor -> move validateForm() -> into EditForm component
    'storyLocal.title': {
      handler (title) {
        if (title === '') {
          this.storyLocal.title = null
        }
      }
    }
  },
  methods: {
    open () {
      this.clearFields()
      this.activePrompt = true
    },
    close () {
      this.activePrompt = false
    },
    clearFields () {
      this.storyLocal = Object.assign({}, this.storyDefaults, { tag: this.defaultTag })
    },
    addStory () {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          await this.$store.dispatch('ADD_STORY', Object.assign({}, this.storyLocal))
          trackAnalytics(this, 'app_action', 'add_story', null, this.$store.getters.daysFromRegistration)
          this.close()
        }
      })
    },
    updateLocalStory (story) {
      this.storyLocal = Object.assign({}, story)
    }
  }
}
</script>
